import React, { Component } from 'react';
import AdminModalForm from '../../../containers/admin/AdminModalForm';
import { MODELS } from '../../../constants/admin/settings';
import StageInputs from './StageInputs';
import PerformancesRow from './PerformancesRow';
import ConfirmationModal from '../forms/ConfirmationModal';
import { CKP_COLOR_RED } from '../../../constants/styling/styles';
import { Tooltip } from '@material-ui/core';

class StageEditor extends Component {
    state = { deleteModal: false };
    componentDidMount() {
        this._fetch();
    }
    componentDidUpdate() {
        this._fetch();
    }
    _fetch() {
        if (this.props.shouldFetchLineup) {
            this.props.fetchLineup(this.props.eventId, this.props.organizationId);
        }
    }
    _delete = id => {
        this.props.closeModalForm();
        this.setState({ deleteModal: id });
    };
    _closeConfirm = () => {
        this.setState({ deleteModal: false });
    };
    _confirmDelete = () => {
        this.props.deleteStage(this.props.eventId, this.state.deleteModal, () => {
            this.setState({ deleteModal: false });
        });
    };
    render() {
        return (
            <div className="ckp-admin-lineup-stages">
                <a className="ckp-admin-lineup-stage-add ckp-ts-h4" onClick={this.props.openStageForm}>
                    + Add Stage
                </a>
                <ul className="ckp-admin-lineup-stages-list">
                    {this.props.stages.map(s => (
                        <li className="u-margin-bottom-3" key={s.id}>
                            <span
                                onClick={() => this.props.openStageForm(s)}
                                className="ckp-ts-h4 ckp-admin-lineup-stages-name"
                            >
                                {s.hidden ? (
                                    <Tooltip title="Stage is hidden.">
                                        <i
                                            className="fa fa-eye-slash u-margin-right-1"
                                            style={{ color: CKP_COLOR_RED }}
                                        />
                                    </Tooltip>
                                ) : null}
                                {s.number} - {s.name}
                            </span>
                            <PerformancesRow
                                artists={this.props.artists}
                                newPerformance={this.props.newPerformance}
                                editPerformance={this.props.editPerformance}
                                performances={s.performances}
                                stage={s}
                            />
                        </li>
                    ))}
                </ul>
                <ConfirmationModal
                    title="Remove Stage"
                    confirmLabel="Delete"
                    confirmText="Are you sure you want to delete this stage?"
                    open={this.state.deleteModal}
                    onClose={this._closeConfirm}
                    onConfirm={this._confirmDelete}
                />
                <AdminModalForm
                    deleteAction={this._delete}
                    title="Stage Details"
                    fields={StageInputs}
                    model={MODELS.STAGE}
                    staticData={{
                        dates: this.props.intervals.map(x => ({ label: x.dayAndMonth, value: x.fullDate }))
                    }}
                    createAction={this.props.createStage}
                    updateAction={this.props.updateStage}
                />
            </div>
        );
    }
}

export default StageEditor;
